/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateRecipientRequest,
  FindByWithSchemaParams,
  GetBankAccountDetailsByRelatedAccountTypeAndRelatedAccountIdParams,
  GetPaymentSchemaByParametersParams,
  GetRecipientsParams,
  RecipientDto,
  RecipientSchema,
  UpdateRecipientRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiBankAccountDetailsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name UpdateBankAccountDetails
   * @request PUT:/api/v1/bank-account-details/{id}
   */
  updateBankAccountDetails = (
    id: string,
    data: UpdateRecipientRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<RecipientDto, any>({
      path: `/v1/bank-account-details/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBankAccountDetailsPath = '/v1/bank-account-details/${id}'
  static updateBankAccountDetailsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name DeleteBankAccountDetails
   * @request DELETE:/api/v1/bank-account-details/{id}
   */
  deleteBankAccountDetails = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/bank-account-details/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteBankAccountDetailsPath = '/v1/bank-account-details/${id}'
  static deleteBankAccountDetailsMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name GetBankAccountDetailsByRelatedAccountTypeAndRelatedAccountId
   * @request GET:/api/v1/bank-account-details
   */
  getBankAccountDetailsByRelatedAccountTypeAndRelatedAccountId = (
    query: GetBankAccountDetailsByRelatedAccountTypeAndRelatedAccountIdParams,
    params: RequestParams = {},
  ) =>
    this.http.request<RecipientDto, any>({
      path: `/v1/bank-account-details`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getBankAccountDetailsByRelatedAccountTypeAndRelatedAccountIdPath =
    '/v1/bank-account-details'
  static getBankAccountDetailsByRelatedAccountTypeAndRelatedAccountIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name CreateBankAccountDetails
   * @request POST:/api/v1/bank-account-details
   */
  createBankAccountDetails = (data: CreateRecipientRequest, params: RequestParams = {}) =>
    this.http.request<RecipientDto, any>({
      path: `/v1/bank-account-details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createBankAccountDetailsPath = '/v1/bank-account-details'
  static createBankAccountDetailsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name IsRecipientValidForPayment
   * @request POST:/api/v1/bank-account-details/{recipientId}/valid-for-payment
   */
  isRecipientValidForPayment = (recipientId: string, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/v1/bank-account-details/${recipientId}/valid-for-payment`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static isRecipientValidForPaymentPath =
    '/v1/bank-account-details/${recipientId}/valid-for-payment'
  static isRecipientValidForPaymentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name GetPaymentSchemaByParameters
   * @request GET:/api/v1/bank-account-details/schema
   */
  getPaymentSchemaByParameters = (
    query: GetPaymentSchemaByParametersParams,
    params: RequestParams = {},
  ) =>
    this.http.request<RecipientSchema, any>({
      path: `/v1/bank-account-details/schema`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getPaymentSchemaByParametersPath = '/v1/bank-account-details/schema'
  static getPaymentSchemaByParametersMethod = 'GET'
  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name GetRecipients
   * @request GET:/api/v1/bank-account-details/list
   */
  getRecipients = (query: GetRecipientsParams, params: RequestParams = {}) =>
    this.http.request<RecipientDto[], any>({
      path: `/v1/bank-account-details/list`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getRecipientsPath = '/v1/bank-account-details/list'
  static getRecipientsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-bank-account-details-controller
   * @name FindByWithSchema
   * @request GET:/api/v1/bank-account-details/find-by-with-schema
   */
  findByWithSchema = (query: FindByWithSchemaParams, params: RequestParams = {}) =>
    this.http.request<RecipientDto, any>({
      path: `/v1/bank-account-details/find-by-with-schema`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findByWithSchemaPath = '/v1/bank-account-details/find-by-with-schema'
  static findByWithSchemaMethod = 'GET'
}
